export enum Page {
  MAINTENANCE = "maintenance",
  REPAIRS = "repairs",
  INSTALLATION = "installation",
}
